export const efundingGeneralFaq = [
  {
    id: 1,
    label: "Pertanyaan Seputar <span style='color: #F7BD3A;'> Efunding </span>",
    child: [
      {
        id: 1,
        title: "Apakah Itu Efunding?",
        description:
          "Efunding adalah platform digital berbasis website yang dikembangkan oleh PT Efunding Teknologi Keuangan, Efunding menghubungkan Anda dengan produk keuangan dari Lembaga Keuangan syariah yang telah bermitra dengan Efunding. Melalui teknologi canggih dan sistem yang user-friendly, memungkinkan calon pengguna untuk mengakses berbagai produk keuangan syariah secara daring dari mana saja tanpa terbatas jarak, tanpa perlu mengunjungi kantor cabang Lembaga Keuangan tertentu.",
      },
      {
        id: 2,
        title: "Siapakah PT Efunding Teknologi Keuangan?",
        description:
          "PT Efunding Teknologi Keuangan adalah perusahaan berbadan hukum resmi di Indonesia yang bergerak dibidang teknologi finansial (fintech) penyelenggara Inovasi Teknologi Sektor Keuangan (ITSK) yang termasuk dalam cluster Agregasi Informasi Produk dan Layanan Jasa Keuangan. Dalam menjalankan kegiatan muamalah-nya Efunding merujuk kepada prinsip syariah atau prinsip hukum ISLAM, sehingga termasuk dalam kategori fintech syariah.",
      },
      {
        id: 3,
        title:
          "Apakah PT Efunding Teknologi Keuangan Memiliki Izin Operasional OJK?",
        description:
          "PT Efunding Teknologi Keuangan telah memiliki lisensi TERDAFTAR dari Otoritas Jasa Keuangan berdasarkan surat nomor S-61/IK.01/2025.",
      },
      {
        id: 4,
        title: "Apakah PT Efunding Teknologi Tergabung Dalam Asosiasi?",
        description:
          "PT Efunding Teknologi Keuangan telah terdaftar sebagai anggota reguler di Asosiasi Fintech Syariah Indonesia (AFSI) sejak Q1 tahun 2019 dengan nomor sertifikat keanggotaan 016/CERT/FIN/IV/2024. Dan merupakan bagian dari Asosiasi Fintech Indonesia (AFTECH).",
      },
      {
        id: 5,
        title: "Apa yang Bisa Saya Dapatkan dari Efunding?",
        description:
          "kami memberikan informasi dan menyediakan layanan pengajuan produk perbankan syariah seperti: Tabungan syariah, Deposito Syariah dan Pembiayaan Syariah. Tentunya dalam hal ini kami juga berusaha bekerjasama dengan Lembaga Keuangan Syariah atau instansi terkait untuk menyediakan data, informasi, dan layanan yang benar dan akurat.",
      },
      {
        id: 6,
        title:
          "Apa Perbedaan Efunding dengan Pihak Mitra seperti BPRS atau Lembaga Keuangan Syariah lainnya?",
        description:
          "kami bekerjasama dengan Pihak Mitra seperti BPRS atau Lembaga Keuangan Syariah sebagai pemilik produk dan jasa untuk menampilkan produk mereka di situs kami. Jadi kami hanya membantu Pihak Mitra dalam memberikan informasi produk kepada Anda selaku konsumen serta membantu dalam proses pengajuan produk yang diinginkan.",
      },
      {
        id: 7,
        title:
          "Apakah Saya Mendapatkan Jaminan Persetujuan dari Produk yang Saya Ajukan jika Mendaftar Melalui Efunding?",
        description:
          "Perlu dicatat bahwa kami tidak mempunyai wewenang untuk memberikan keputusan apakah Anda berhak untuk mendapatkan produk atau jasa tersebut. BPRS atau Lembaga Keuangan Syariah terkaitlah yang memiliki wewenang dalam pengambilan keputusan. Akan tetapi, kami memiliki kewajiban untuk mengumpulkan dan melakukan pengecekan data atau dokumen yang dibutuhkan dalam proses pengajuan sebelum diteruskan ke pihak mitra. Tentunya, kami akan berusaha sebaik mungkin untuk dapat memproses aplikasi pengajuan tersebut supaya bisa diterima dengan baik ke Pihak Mitra yang bersangkutan.",
      },
      {
        id: 8,
        title: "Apa Kelebihan Efunding?",
        description: `
          <ul style='list-style: disc;'>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Akses ke Produk Keuangan Syariah: Calon funder dapat mengakses berbagai produk keuangan syariah dari Lembaga Keuangan Syariah (LKS) Mitra Efunding, seperti tabungan syariah dan deposito syariah, tanpa perlu datang ke kantor cabang.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Informasi Lengkap dan Transparan: Efunding menyediakan informasi detail mengenai produk, termasuk syarat, ketentuan, dan profil LKS Mitra. Ini memudahkan calon funder untuk memilih produk yang sesuai dengan kebutuhan.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Informasi Lengkap dan Transparan: Efunding menyediakan informasi detail mengenai produk, termasuk syarat, ketentuan, dan profil LKS Mitra. Ini memudahkan calon funder untuk memilih produk yang sesuai dengan kebutuhan.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Keamanan Data dan Transaksi: Dengan dukungan teknologi modern, Efunding memastikan keamanan data pengguna sekaligus memberikan pengalaman bertransaksi yang cepat dan efisien</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Akses Tanpa Batas Geografis: Calon funder dapat menjangkau produk LKS mitra di seluruh Indonesia melalui platform digital Efunding, tanpa terkendala lokasi.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Proses Online yang Mudah: Seluruh proses, mulai dari registrasi hingga pengajuan produk, dilakukan secara daring, memberikan kenyamanan dan efisiensi waktu bagi calon funder.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Proses Online yang Mudah: Seluruh proses, mulai dari registrasi hingga pengajuan produk, dilakukan secara daring, memberikan kenyamanan dan efisiensi waktu bagi calon funder.</p>
            </li>
          </ul>
        `,
      },
    ],
  },
  {
    id: 2,
    label:
      "Pertanyaan Tentang Keamanan Akun di <span style='color: #F7BD3A;'> Efunding </span>",
    child: [
      {
        id: 1,
        title: "Apakah Menggunakan Layanan di Efunding Aman?",
        description:
          "Efunding.id berkomitmen untuk melindungi dan merahasiakan data pribadi Anda. Seluruh data atau informasi yang Anda masukkan selama proses pengajuan dilindungi menggunakan teknologi enkripsi dan keamanan termutakhir sehingga terlindungi dengan baik.",
      },
      {
        id: 2,
        title:
          "Hal-Hal yang Harus Diperhatikan Supaya Akun dan Data Anda Tetap Aman",
        description: `
            <ul style='list-style: disc;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'> Agar keamanan data pribadi Anda tetap selalu terjaga, berikut beberapa tips dan hal yang perlu diperhatikan: </p>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Jangan Sembarangan Memberikan Informasi Pribadi </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jangan pernah sembarangan memberikan informasi pribadi kepada siapapun di luar situs Efunding. Data pribadi yang dimaksud antara lain adalah informasi pribadi, sandi (password), KTP, Foto Selfie, NPWP, dll.</p>
              </li>
             <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Jaga Kerahasiaan Kode OTP </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jangan memberikan kode OTP yang masuk melalui SMS / e-mail kepada siapapun termasuk pihak-pihak yang mengatasnamakan diri sebagai Efunding.</p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Jangan Berkomentar Sembarangan </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jangan pernah mempublikasikan data pribadi Anda di kolom komentar media sosial manapun agar tetap aman.</p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Waspada Terhadap Akun Media Sosial Palsu </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Hati-hati terhadap segala informasi yang diberikan oleh akun palsu yang mengatasnamakan diri sebagai Efunding. Berikut akun media sosial Efunding yang terverifikasi:</p>
                <ul style='list-style: disc;'>
                  <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Instagram Resmi Efunding (@efunding.id)</li>
                  <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Facebook Resmi Efunding (@efunding.id)</li>
                </ul>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Waspada Terhadap Link Mencurigakan </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Website resmi Efunding hanya bisa diakses pada domain https://efunding.id/. Mohon hati-hati apabila Anda menerima pesan atau informasi dari seseorang untuk mengakses/mengklik link tertentu di luar website atau akun media sosial resmi Efunding.</p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Perhatikan Alamat e-mail Resmi Efunding </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Penyampaian informasi promo, pengajuan, dan informasi lainnya via e-mail hanya dilakukan lewat alamat e-mail resmi Efunding berikut ini:</p>
                <ul style='list-style: disc;'>
                  <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>@efunding.id</li>
                </ul>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Abaikan apabila menerima e-mail lain dengan alamat berbeda yang mengatasnamakan diri sebagai pihak Efunding</p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify; font-weight: 600;'>Selalu Perbarui Sandi Akun Efunding Anda </p>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Supaya akun tetap aman, perbarui sandi akun Efunding Anda setiap 3 bulan sekali. Pembaruan sandi bisa dilakukan melalui menu akun saya dan pilih ganti kata sandi. Apabila lalai atau merasa akun Anda tidak aman, segera lakukan pergantian sandi akun Efunding Anda supaya akun tetap aman.</p>
              </li>
            </ul>
          `,
      },
    ],
  },
  {
    id: 3,
    label:
      "Pertanyaan Tentang Proses <span style='color: #F7BD3A;'> Pengajuan Aplikasi</span>",
    child: [
      {
        id: 1,
        title: "Bagaimana Caranya Mengajukan Permohonan Aplikasi di Efunding?",
        description:
          "Anda dapat mengunjungi platform kami di https://efunding.id Anda tinggal melihat dan membandingkan produk mana yang dibutuhkan, dan setelah menentukan pilihan, Anda akan dipersilakan untuk mengisi form aplikasi. Harap aplikasi ini diisi dengan data Anda yang sebenarnya. Kemudian aplikasi ini akan kami simpan dalam database kami, dan kemudian akan diteruskan kepada Pihak Mitra terkait (BPRS atau Lembaga Keuangan Syariah terkait). Jika Anda telah mengisi form aplikasi dengan benar, Pihak Mitra akan segera menghubungi Anda untuk memproses pengajuan Anda.",
      },
      {
        id: 2,
        title:
          "Apakah Saya Harus Memberikan Kontak dan Detail Informasi yang Valid?",
        description:
          "Ya. Informasi yang benar dan valid akan membantu kami dalam mengidentifikasi Anda dan tentunya juga akan memudahkan Pihak Mitra dalam menghubungi dan memproses aplikasi pengajuan. Jika Anda mengajukan produk perbankan, biasanya Pihak Mitra akan meminta detail alamat Anda dengan benar untuk melakukan proses survey. Jika Anda memberikan data kontak dan detail yang benar dan valid, tentunya akan memperbesar peluang Anda untuk mendapatkan persetujuan aplikasi.",
      },
      {
        id: 3,
        title:
          "Apa Harus Saya Lakukan Selanjutnya Setelah Mengajukan Aplikasi Secara Online?",
        description:
          "Setelah Anda mengisi form aplikasi, Anda cukup menunggu dan akan segera dihubungi oleh kami ataupun Pihak Mitra untuk melakukan verifikasi. Seperti jawaban di atas, harap dicatat bahwa data yang berikan dalam form aplikasi haruslah benar dan valid untuk memudahkan proses verifikasi. Setelah Anda melengkapi form aplikasi, harap juga menyiapkan dokumen-dokumen terkait yang diperlukan tergantung jenis produk apa yang ajukan. Misal Anda mengajukan produk perbankan syariah, maka siapkan dokumen yang secara umum harus disiapkan adalah sebagai berikut: fotocopy KTP, fotocopy slip gaji terakhir Anda, serta dokumen yang diperlukan lainnya.",
      },
      {
        id: 4,
        title:
          "Apakah Ada Biaya Tambahan yang Harus Saya Bayar Jika Mengajukan Aplikasi Melalui Efunding?",
        description:
          "Tidak ada biaya yang kami bebankan Anda jika melakukan pengajuan aplikasi melalui platform kami. Semua kami berikan secara gratis. Semua ini untuk membantu Anda mendapatkan informasi dan mengambil keputusan secara cermat.",
      },
      {
        id: 5,
        title:
          "Apakah Memungkinkan Bagi Saya untuk Mengajukan Lebih Dari Satu Aplikasi Produk Secara Bersamaan?",
        description:
          "Sangat dimungkinkan bagi Anda untuk mengajukan lebih dari satu aplikasi produk secara bersamaan. Namun harus diingat kembali, bahwa pengajuan harus disesuaikan dengan kebutuhan Anda saat ini serta kemampuan Anda untuk memfasilitasi produk yang Anda inginkan. Sebagai contoh, Anda juga harus cermat dalam melakukan penghitungan pengeluaran Anda untuk membayar angsuran jika Anda mengajukan permohonan KPR dan Kepemilikan Kendaraan secara bersamaan.",
      },
      {
        id: 6,
        title:
          "Apakah Memungkinan Bagi Saya untuk Mendapatkan Persetujuan Aplikasi Dalam Hari yang Sama?",
        description:
          "Efunding tidak mempunyai wewenang dalam memberikan persetujuan aplikasi Anda. Selain itu setiap pengajuan aplikasi memerlukan proses pengecekan kelengkapan dokumen serta verifikasi data terlebih dahulu. Namun tentunya kami akan berusaha sebaik mungkin untuk dapat memproses pengajuan Anda dan meneruskan detail pengajuan Anda kepada Pihak Mitra terkait.",
      },
      {
        id: 7,
        title:
          "Apa yang Harus Saya Pelajari Sebelum Melakukan Pengajuan Aplikasi?",
        description:
          "Sesuaikan produk dengan kebutuhan Anda. Selain itu juga sesuaikan dengan penghasilan serta pengeluaran. Dan jangan khawatir, jika Anda membutuhkan tips finansial, Anda bisa mengunjungi halaman detail tiap-tiap produk di Efunding untuk mendapatkan informasi seputar keuangan serta informasi mengenai produk-produk terbaru yang dapat disesuaikan dengan kebutuhan Anda. Selain itu Anda juga kami sarankan untuk membaca terlebih dahulu Syarat dan Ketentuan sebelum mengakses Situs kami lebih lanjut.",
      },
      {
        id: 8,
        title:
          "Bagaimana Cara Saya Mengetahui Detail Produk yang Saya Inginkan?",
        description:
          "Caranya sangat mudah, Anda tinggal tentukan produk mana yang akan Anda lihat detailnya, kemudian Anda klik tombol 'Info Lengkap' untuk informasi lengkap mengenai produk tersebut. Kemudian pada halaman detail produk akan muncul berbagai informasi seperti cara pengajuan, biaya-biaya terkait, fitur yang diberikan, ataupun promosi yang berlaku. Cara lain adalah Anda tinggal klik gambar produk terkait untuk memunculkan informasi secara lengkap.",
      },
      {
        id: 9,
        title: "Apakah Saya Dapat Membatalkan Pengajuan Aplikasi?",
        description:
          "Jika Anda telah melakukan pengajuan dan ingin membatalkannya, Anda dapat membatalkan pengajuan melalui tombol “Batalkan” yang tersedia pada menu Pengajuan Saya di dashboard Anda. Selain itu, Anda juga dapat mengirimkan email kepada tim support kami melalui email ke support@efunding.id dengan memberikan penjelasan atau alasan pembatalan.",
      },
    ],
  },
  {
    id: 4,
    label:
      "Pertanyaan Seputar <span style='color: #F7BD3A;'> Produk & Mitra Efunding </span>",
    child: [
      {
        id: 1,
        title: "Apa itu Lembaga Keuangan Syariah Mitra?",
        description:
          "Lembaga Keuangan Syariah Mitra yang selanjutnya disingkat LKSM adalah Lembaga yang melaksanakan kegiatan di sektor perbankan, sektor keuangan syariah non perbankan dan sektor keuangan lainnya sesuai prinsip syariah yang telah bermitra dengan Efunding. Saat ini LKSM Efunding adalah BPRS.",
      },
      {
        id: 2,
        title: "Apa itu Bank Perekonomian Rakyat Syariah (BPRS)?",
        description: `
            <ul style='list-style: disc;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>BPRS adalah Bank Perekonomian Rakyat Syariah yang melaksanakan kegiatan usaha berdasarkan prinsip syariah, yang dalam kegiatannya tidak memberikan jasa dalam lalu-lintas pembayaran. Merujuk pada definisi Otoritas Jasa Keuangan (OJK), maka Bank Perekonomian Rakyat Syariah (BPRS) adalah bank yang secara fungsi melaksanakan kegiatan usaha berdasarkan prinsip syariah dan dalam praktiknya tidak memberikan jasa dalam lalu lintas pembayaran. Tidak beda jauh dengan BPR konvensional, BPRS dilarang menerima simpanan giro, valas, dan perasuransian. Kendati demikian, meskipun secara fungsi dan kegiatan serupa, namun BPRS tidak dapat dikonversi menjadi BPR konvensional, karena secara prinsip berbeda. Apabila BPR konvensional menggunakan prinsip umum perbankan dalam aktivitasnya, maka BPRS menerapkan prinsip ekonomi syariah. Adapun lima kegiatan usaha yang bisa dilakukan oleh BPRS antara lain:</p>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Menghimpun dana dari masyarakat; </p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Menyalurkan dana kepada masyarakat;</p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Menempatkan dana kepada bank syariah lainnya dalam bentuk: </p>
                <ul style='list-style: disc;'>
                  <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                    <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>titipan berdasarkan akad Wadi’ah; dan</p>
                  </li>
                   <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                    <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>investasi berdasarkan akad Mudharabah; dan/atau akad lain yang masih sejalan dengan prinsip-prinsip syariah; </p>
                  </li>
                </ul>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Memindahkan uang, baik untuk kepentingan pribadi maupun nasabah melalui rekening BPRS yang ada di Bank Umum Syariah, Bank Umum Konvensional, dan/atau Unit Usaha Syariah (UUS).</p>
              </li>
               <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'>
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Menyediakan produk atau melakukan kegiatan kegiatan Bank Syariah lainnya yang tidak bertentangan dengan prinsip syariah dan atas persetujuan Bank Indonesia.</p>
              </li>
            </ul>
          `,
      },
      {
        id: 3,
        title: "Apa itu Tabungan Syariah?",
        description:
          "Tabungan syariah adalah produk simpanan yang dikeluarkan oleh lembaga keuangan syariah, seperti bank syariah maupun BPR Syariah. Jenis tabungan ini disebut syariah karena seluruh transaksi dan akadnya menggunakan dasar aturan Islam. Seluruh BPRS yang tersedia di dalam platform Efunding telah terdaftar dan diawasi oleh Otoritas Jasa Keuangan (OJK).",
      },
      {
        id: 4,
        title: "Akad apa yang digunakan dalam Tabungan Syariah?",
        description:
          "Akad yang digunakan oleh Tabungan Syariah adalah prinsip Wadiah dan Mudharabah.",
      },
      {
        id: 5,
        title: "Apa itu prinsip Wadiah?",
        description:
          "Tabungan syariah dengan akad wadiah adalah jenis tabungan yang menggunakan prinsip wadiah yad dhamanah (titipan dengan jaminan). Dalam akad ini, nasabah menitipkan dana kepada Lembaga Keuangan Syariah untuk disimpan dan dikelola dengan aman, tanpa harapan untuk mendapatkan imbal hasil yang bersifat pasti.",
      },
      {
        id: 6,
        title: "Apa itu Deposito Syariah?",
        description:
          "Deposito Syariah menawarkan produk Deposito yang dimiliki oleh BPRS dalam bentuk Mudharabah. Produk ini memberikan Anda kesempatan untuk mengalokasikan dana produk simpanan pada BPRS yang pencairannya kelak berdasarkan akad bagi hasil yang telah disepakati bersama. Seluruh BPRS yang tersedia di dalam platform Efunding telah terdaftar dan diawasi oleh Otoritas Jasa Keuangan (OJK).",
      },
      {
        id: 7,
        title: "Akad apa yang digunakan dalam Deposito Syariah?	",
        description:
          "Akad yang digunakan oleh Deposito Syariah adalah prinsip Mudharabah.",
      },
      {
        id: 8,
        title: "Apa itu prinsip Mudharabah?",
        description:
          "Deposito Mudharabah adalah dana nasabah yang disimpan di bank syariah dimana pengembaliannya berdasarkan jangka waktu (tenor)yang telah ditentukan. Sedangkan tingkat bagi hasil (return) dari prinsip Mudharabah adalah tergantung nisbah bagi hasil yang telah disepakati bersama.",
      },
      {
        id: 9,
        title: "Kapan Saya Akan Mendapatkan Bagi Hasil Untuk Deposito Syariah?",
        description: `
          <ul style='list-style: disc;'>
            <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'> Dalam sistem deposito syariah, waktu bagi hasil bergantung pada kesepakatan antara funder dan Lembaga Keuangan Syariah (LKS) yang menawarkan produk tersebut. Informasi spesifik terkait waktu distribusi biasanya tercantum dalam syarat dan ketentuan produk atau akad yang digunakan. Namun, secara umum, berikut adalah beberapa pola umum periode bagi hasil deposito syariah:</p>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Bulanan: Bagi hasil dibagikan setiap akhir bulan.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Setiap Akhir Periode Deposito: Bagi hasil dibayarkan setelah jatuh tempo deposito, misalnya 3 bulan, 6 bulan, atau 1 tahun.</p>
            </li>
          </ul>
        `
      },
      {
        id: 10,
        title: "Apakah Deposito Syariah Di Platform Efunding Dapat Dicairkan Sebelum Jatuh Tempo?",
        description:
          "Pencairan sebelum jatuh tempo dapat dilakukan mengikuti sesuai dengan ketentuan yang berlaku di masing-masing Lembaga Keuangan Syariah Mitra.",
      },
      {
        id: 11,
        title: "Berapa Jangka Waktu Deposito Syariah?",
        description:
          "Deposito Syariah di platform Efunding menyediakan berbagai pilihan tenor waktu mulai dari 1 bulan, 3 bulan, 6 bulan dan 12 bulan.",
      },
      {
        id: 12,
        title: "Benefit / Layanan Apa Saja Yang Dapat Diperoleh Nasabah Yang Memiliki Deposito Syariah?",
        description: `
          <ul style='list-style: disc;'>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Deposito Syariah menawarkan layanan deposito berdasarkan prinsip syariah dengan skema bagi hasil yang menarik.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Setiap Akhir Periode Deposito: Bagi hasil dibayarkan setelah jatuh tempo deposito, misalnya 3 bulan, 6 bulan, atau 1 tahun.</p>
            </li>
          </ul>
        `
      },
      {
        id: 11,
        title: "Siapa Saja yang Dapat Menjadi Deposan Melalui Platform Efunding?",
        description:
          "Seluruh Warga Negara Indonesia (WNI) dengan usia minimal 17 tahun dan memiliki Kartu Tanda Penduduk (KTP) elektronik.",
      },
      {
        id: 12,
        title: "Benefit / Layanan Apa Saja Yang Dapat Diperoleh Nasabah Yang Memiliki Deposito Syariah?",
        description: `
          <ul style='list-style: disc;'>
            <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Anda akan menerima bilyet fisik Deposito setelah transaksi pembukaan deposito berhasil. Metode penyerahan bilyet deposito dari mitra BPRS kepada Deposan adalah sebagai berikut:</p>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Bilyet dikirimkan langsung ke alamat Deposan.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Dalam hal pengiriman bilyet fisik ke alamat Deposan, BPRS diwajibkan untuk melakukan upload/ unggah bukti / resi pengiriman di platform.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Deposan pun diwajibkan untuk memberikan konfirmasi penerimaan bilyet di platform apabila bilyet telah diterima.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>BPRS diwajibkan melakukan konfirmasi terlebih dahulu ke Deposan terkait dengan pengiriman Bilyet Deposito. Selain itu, Anda dapat melihat copy bilyet deposito Anda melalui platform Efunding.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Harap diperhatikan bahwa bilyet deposito WAJIB diterbitkan oleh Mitra BPRS.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>PT Efunding Teknologi Keuangan tidak melakukan penerbitan bilyet fisik, namun hanya menampilkan copy bilyet melalui platform.</p>
            </li>
          </ul>
        `
      },
      {
        id: 12,
        title: "Benefit / Layanan Apa Saja Yang Dapat Diperoleh Nasabah Yang Memiliki Deposito Syariah?",
        description: `
          <ul style='list-style: disc;'>
            <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Pada bilyet deposito yang diterima oleh nasabah akan terdapat informasi sebagai berikut: Bilyet fisik</p>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Bilyet dikeluarkan oleh BPR terkait lengkap dengan nama dan logo BPR</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Memiliki nomor registrasi bilyet.</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Dilengkapi dengan informasi:</p>
              <ul style='list-style: disc;'>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                  <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Nomor rekening deposito</p>
                </li>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                  <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Nama pemilik rekening deposito</p>
                </li>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                  <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jumlah penempatan deposito</p>
                </li>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                  <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Informasi Suku bunga deposito (BPR konvensional), dan Bagi Hasil (BPR Syariah)</p>
                </li>
                <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                  <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Tenor/jangka waktu deposit</p>
                </li>
              </ul>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Ditandatangani oleh minimal 1 pengurus setingkat Direksi</p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Bilyet dibubuhi stempel atas nama BPR.</p>
            </li>
          </ul>
        `
      },
      {
        id: 13,
        title: "Apa yang Perlu Saya Lakukan Untuk Pencairan Deposito Saya yang Memasuki Masa Jatuh Tempo?",
        description: `
          <div>
            <ul style='list-style: disc;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Berikut adalah hal yang harus dilakukan oleh Deposan dalam situasi bilyet fisik hilang: </p>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Deposan membuat surat keterangan dari pihak kepolisian yang menyatakan bahwa bilyet fisik hilang. </p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jika laporan kehilangan bilyet dilakukan kurang dari 14 hari setelah bilyet dikirimkan, pihak Efunding dapat membantu pengurusan surat kehilangan (SUKEPOL). </p>
              </li> 
            </ul>

            <ul style='list-style: disc;'>
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Akan tetapi jika pelaporan kehilangan dilakukan lebih dari 14 hari setelah tanggal pengiriman bilyet, maka deposan harus mengurus SUKEPOL secara mandiri. Berikut prosedur yang harus dilakukan oleh deposan: </p>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Deposan membuat surat pernyataan tertulis yang ditujukan kepada BPRS terkait kehilangan bilyet fisik. </p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Setelah itu, Deposan dapat mem-backup kedua dokumen tersebut dalam bentuk softcopy dan dikirimkan juga ke pihak Efunding. </p>
              </li>              
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Setelah pengiriman data, deposan dapat menghubungi Customer Support Efunding untuk melakukan konfirmasi data dan mendapatkan bantuan untuk proses pengiriman 2 dokumen tersebut kepada BPRS yang bersangkutan. </p>
              </li>
              <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
                <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Setelah itu, Deposan dapat menunggu konfirmasi dari BPRS untuk proses lebih lanjut.</p>
              </li>
            </ul>
          </div>
        `
      },
      {
        id: 14,
        title: "Bagaimana Jika Bilyet Fisik Saya Hilang Pada Saat BPRS Mengirimkan Bilyet Kepada Nasabah?",
        description: `
          <ul style='list-style: disc;'>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jika tidak terdapat kendala, deposan akan mendapatkan bilyet fisik maksimal H+14 setelah deposito aktif.  </p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jika deposan belum menerima bilyet fisik dalam kurun waktu 14 hari setelah deposito aktif, segera hubungi tim Customer Support Efunding untuk membantu proses pelacakan. </p>
            </li>            
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jika deposan melaporkan belum menerima bilyet fisik / kehilangan bilyet fisik setelah 21 hari sejak deposito aktif, maka pihak Efunding tidak dapat bertanggungjawab membantu proses pelacakan serta pengurusan kehilangan. Deposan dapat mengurus proses pembuatan surat pernyataan kehilangan di kepolisian secara mandiri. </p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jika deposan melaporkan belum menerima bilyet fisik / kehilangan bilyet fisik dalam 14 hari sejak deposito aktif, pihak Efunding dapat membantu prosedur administrasi berupa pengurusan surat pernyataan kehilangan di kepolisian. </p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Jika proses administrasi kehilangan bilyet belum selesai hingga tanggal jatuh tempo deposito, mitra BPRS terkait tidak akan membayarkan nisbah bagi hasil setelah tanggal jatuh tempo. </p>
            </li>
            <li style='color: #f0f0f0; font-size: 18px; text-align: justify;'> 
              <p style='color: #f0f0f0; font-size: 18px; text-align: justify;'>Mitra BPRS terkait hanya berkewajiban untuk membayarkan nisbah bagi hasil sesuai tanggal jatuh tempo deposito.</p>
            </li>
          </ul>
        `
      },
    ],
  },
  {
    id: 5,
    label: "Pertanyaan <span style='color: #F7BD3A;'> Bantuan </span> Lainnya",
    child: [
      {
        id: 1,
        title: "Bagaimana Cara Menghubungi Efunding?",
        description:
          "Jika Anda memiliki pertanyaan atau menginginkan informasi lainnya, Anda dapat menghubungi nomor Customer Service kami di nomor: +62 818-227-070 setiap hari Senin sampai Jumat pukul 09.00 WIB s/d 17.00 WIB. Untuk pertanyaan lebih lanjut, Anda juga dapat mengirimkan pertanyaan e-mail ke: support@efunding.id",
      },
      {
        id: 2,
        title: "Bagaimana Cara Saya Menghubungi Efunding di Hari Libur?",
        description:
          "Khusus untuk Sabtu dan Minggu, atau Hari Libur lainnya, Anda dapat menghubungi kami via email ke: support@efunding.id. Kami akan berusaha memberikan jawaban serta respons terbaik demi kepuasan Anda.",
      },
      {
        id: 3,
        title:
          "Bisakah Saya Meminta Bantuan Customer Service untuk Melakukan Proses Pengajuan Aplikasi?",
        description:
          "Customer Service kami hanya akan membantu mengarahkan Anda untuk mengakses Situs kami dan memberikan tips seputar akses atau konten yang sebaiknya Anda tuju. Harap diingat bahwa untuk proses pengajuan, Anda akan diminta mengisi sendiri detail informasi pribadi dan informasi lainnya yang diminta pada form aplikasi, sehingga tim Customer Service kami tidak dapat membantu Anda mengisikan form aplikasi.",
      },
      {
        id: 4,
        title:
          "Saya Tidak Dapat Mengakses Situs Efunding Saat Ini, Apa yang Harus Saya Lakukan?",
        description:
          "Hal pertama yang harus Anda pastikan adalah periksa kembali pengaturan koneksi internet Anda. Kami memberikan platform perbandingan secara gratis via internet, dan tidak memerlukan aplikasi khusus yang perlu di-instal pada perangkat Anda. Jika masih membutuhkan bantuan teknis lainnya, Anda juga dapat menghubungi Customer Service kami di di nomor: +62 818-227-070 atau e-mail ke: support@efunding.id",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/utils/efunding_faq_general.js